import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PaymentPageAscend.css";

const SERVICE_NAME = "Forge Your Peak - Ascend";
const PRODUCT_PRICE = 49999;

const PaymentPageAscend = () => {
    useEffect(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, []);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const navbar = document.querySelector("header, .navbar");
    const footer = document.querySelector("footer");

    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";

    return () => {
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhoneChange = (phone) => {
    setFormData((prev) => ({
      ...prev,
      phone,
    }));
  };

  const handlePayment = async () => {
    try {
      // ============================================
      // VALIDATION
      // ============================================

      if (!formData.name.trim()) {
        alert("Please enter your full name.");
        return;
      }

      if (!formData.email.trim()) {
        alert("Please enter your email address.");
        return;
      }

      if (!formData.phone.trim()) {
        alert("Please enter your phone number.");
        return;
      }

      // ============================================
      // CHECK RAZORPAY
      // ============================================

      if (!window.Razorpay) {
        alert("Razorpay checkout is not loaded.");
        return;
      }

      setIsLoading(true);

      // ============================================
      // CREATE RAZORPAY ORDER
      // ============================================

      const response = await axios.post(
        "/api/razorpay/create-order",
        {
          name: formData.name.trim(),
          email: formData.email.trim().toLowerCase(),
          phone: formData.phone,
          service: SERVICE_NAME,
        }
      );

      const data = response.data;

      console.log(
        "Razorpay Order Response:",
        data
      );

      if (!data.success) {
        throw new Error(
          data.message ||
            "Unable to create payment order."
        );
      }

      // ============================================
      // OPEN RAZORPAY CHECKOUT
      // ============================================

      const options = {
        key: data.keyId,

        amount: data.order.amount,

        currency: data.order.currency,

        name: "Forge Your Peak",

        description: SERVICE_NAME,

        order_id: data.order.id,
         config: {
            display: {
              hide: [
                {
                  method: "emi",
                },
              ],

              preferences: {
                show_default_blocks: true,
              },
            },
          },
        prefill: {
          name: formData.name.trim(),
          email: formData.email
            .trim()
            .toLowerCase(),
          contact: formData.phone,
        },

        notes: {
          service: SERVICE_NAME,
        },

        theme: {
          color: "#20264F",
        },

        // ==========================================
        // PAYMENT SUCCESS
        // ==========================================

        handler: async function (paymentResponse) {
          try {
            console.log(
              "Razorpay Payment Response:",
              paymentResponse
            );

            // ========================================
            // VERIFY PAYMENT WITH BACKEND
            // ========================================

            const verifyResponse =
              await axios.post(
                "/api/razorpay/verify-payment",
                {
                  razorpay_order_id:
                    paymentResponse.razorpay_order_id,

                  razorpay_payment_id:
                    paymentResponse.razorpay_payment_id,

                  razorpay_signature:
                    paymentResponse.razorpay_signature,
                }
              );

            const verifyData =
              verifyResponse.data;

            console.log(
              "Payment Verification Response:",
              verifyData
            );

            // ========================================
            // VERIFICATION FAILED
            // ========================================

            if (!verifyData.success) {
              throw new Error(
                verifyData.message ||
                  "Payment verification failed."
              );
            }

            // ========================================
            // PAYMENT VERIFIED
            // ========================================

            console.log(
              "✅ Payment verified successfully."
            );

            console.log(
              "Activated User:",
              verifyData.user
            );

            // ========================================
            // META PURCHASE EVENT
            // ========================================

           
              

            // ========================================
            // STOP LOADING
            // ========================================

            setIsLoading(false);

            // ========================================
            // SUCCESS MESSAGE
            // ========================================

            alert(
              "Payment successful! Your access has been activated."
            );

            // ========================================
            // REDIRECT TO DASHBOARD LOGIN
            // ========================================

            navigate("/dashboard-login", {
              replace: true,
            });

          } catch (error) {
            console.error(
              "❌ Payment verification error:",
              error
            );

            setIsLoading(false);

            alert(
              error.response?.data?.message ||
                error.message ||
                "Payment verification failed. Please contact support."
            );
          }
        },

        // ==========================================
        // CHECKOUT CLOSED
        // ==========================================

        modal: {
          ondismiss: () => {
            console.log(
              "Razorpay Checkout closed."
            );

            setIsLoading(false);
          },
        },
      };

      // ============================================
      // RAZORPAY INSTANCE
      // ============================================

      const razorpay =
        new window.Razorpay(options);

      // ============================================
      // PAYMENT FAILED
      // ============================================

      razorpay.on(
        "payment.failed",
        (response) => {
          console.error(
            "❌ Razorpay payment failed:",
            response.error
          );

          setIsLoading(false);

          alert(
            response.error?.description ||
              "Payment failed. Please try again."
          );
        }
      );

      // ============================================
      // OPEN CHECKOUT
      // ============================================

      razorpay.open();

    } catch (error) {
      console.error(
        "❌ Payment initialization error:",
        error
      );

      setIsLoading(false);

      alert(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong while starting the payment."
      );
    }
  };

  return (
    <div className="ascend-payment-page">

      {/* =========================================
          LEFT
      ========================================= */}

      <section className="ascend-payment-left">

        <div className="ascend-left-inner">

          <div className="ascend-company-logo">
            <img
              src="/Logo.png"
              alt="Forge Your Peak"
            />
          </div>

          <div className="ascend-product-header">

            <h1>
              Forge Your Peak – Ascend
            </h1>

            <p>
              By ForgeYourPeak
            </p>

            <div className="ascend-product-price">
              ₹49,999
            </div>

          </div>

          <div className="ascend-product-description">

            <p className="ascend-intro">
              A 90-day personalized
              neuro-performance coaching
              program for athletes who want
              direct guidance, accountability,
              and a customized roadmap.
            </p>

            <p>
              While Ignite teaches the framework,
              Ascend adapts it to your sport,
              position, strengths, weaknesses,
              and competitive goals.
            </p>

            <p>
              Through weekly 1-on-1 coaching
              sessions, continuous assessment,
              and personalized training
              prescriptions, you'll focus on
              the specific performance
              bottlenecks holding you back and
              develop the skills that matter
              most for your game.
            </p>

            <h2>
              What is included?
            </h2>

            <ul>
              <li>
                Weekly 1-on-1 coaching sessions
              </li>

              <li>
                Personalized performance roadmap
              </li>

              <li>
                Complete Ignite curriculum
              </li>

              <li>
                Monthly performance reassessments
              </li>

              <li>
                Custom training prescriptions
              </li>

              <li>
                Performance dashboard and
                progress tracking
              </li>

              <li>
                Direct feedback and accountability
              </li>

              <li>
                Priority support
              </li>
            </ul>

            <h2>
              The Outcome
            </h2>

            <p>
              Over 90 days, you'll build a system
              tailored to your unique performance
              profile, ensuring every training
              session contributes directly to
              better execution, faster decisions,
              improved consistency, and greater
              confidence in competition.
            </p>

          </div>

        </div>

      </section>

      {/* =========================================
          RIGHT
      ========================================= */}

      <section className="ascend-payment-right">

        <div className="ascend-payment-right-inner">

          <h2>
            Payment details
          </h2>

          <p className="ascend-payment-subtitle">
            Complete your purchase by providing
            your payment details.
          </p>

          {/* Billing */}

          <div className="ascend-billing-card">

            <h3>
              Billing information
            </h3>

            <div className="ascend-billing-fields">

              <input
                type="text"
                name="name"
                placeholder="Full name"
                value={formData.name}
                onChange={handleChange}
                disabled={isLoading}
              />

              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                disabled={isLoading}
              />

              <div className="ascend-phone-wrapper">

                <PhoneInput
                  country="in"
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  enableSearch={true}
                  countryCodeEditable={false}
                  placeholder="Phone number"
                  inputProps={{
                    name: "phone",
                    required: true,
                  }}
                  containerClass="ascend-phone-container"
                  inputClass="ascend-phone-input"
                  buttonClass="ascend-phone-button"
                  dropdownClass="ascend-phone-dropdown"
                  disabled={isLoading}
                />

              </div>

            </div>

          </div>

          {/* Order */}

          <div className="ascend-order-card">

            <div className="ascend-order-top-line"></div>

            <div className="ascend-order-content">

              <h3>
                Service
              </h3>

              <div className="ascend-service-row">

                <span>
                  Forge Your Peak - Ascend
                </span>

                <strong>
                  ₹49999.00
                </strong>

              </div>

              <div className="ascend-divider"></div>

              <div className="ascend-total-row">

                <span>
                  Amount to be paid :
                </span>

                <strong>
                  ₹49999.00
                </strong>

              </div>

            </div>

          </div>

          {/* Pay */}

          <button
            type="button"
            className="ascend-pay-button"
            onClick={handlePayment}
            disabled={isLoading}
          >
            {isLoading
              ? "Processing..."
              : "Proceed to pay ₹49999.00"}
          </button>

        </div>

      </section>

    </div>
  );
};

export default PaymentPageAscend;